module.exports = __webpack_public_path__ + "static/logo-ucsc-gi-18274131c77c8e396900b0923f0f49ee.png";